module.exports = __webpack_public_path__ + "static/media/example4.94246ba6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/About/example4.gif
// module id = 1241
// module chunks = 2